import { LOAD_USERS } from '../../smart_contract/constants/ActionTypes';

export default (state = [], action) => {
  switch (action.type) {
    case LOAD_USERS: {
      return action.payload;
    }
    default:
      return state;
  }
};
